import * as React from "react";
import EdButton from "../../../../generic/edButton";
import ObMfDtlContent from "../dsk/obMfDtlContent";
import ObAssetsDetlMob from "../../instruments/details/obAssetsDetlMob";
import "../../../../../assets/scss/components/toc/orderBook/obDetails/obAssetDetailsMob.scss";
import moment from "moment";
import { ObAssetsDetlProps } from "../../instruments/details/obAssetsDetl";
import { ChipStatusComb } from "../../obConstants";

export interface IObMfDtlMobProps {
	data: any;
	onBackClick: (event: React.MouseEvent<HTMLButtonElement>) => void; // the function to be called onClick
	onCancelClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const ObMfDtlMob: React.FC<IObMfDtlMobProps> = (props) => {
	const backButtonValue = (
		<>
			<i className="arrow_left edel-icon-arrow-left vTextTop" />
			<span>Back</span>
		</>
	);

	const assetDetail: ObAssetsDetlProps = {
		date: props.data.txnDate ? moment(new Date(props.data.txnDate)).format("D MMM YYYY, HH:mm:ss") : "",
		trsTyp: "BUY",
		title: props.data.schemeName,
		sts: ChipStatusComb[props.data.status.toLowerCase()]
	};

	return (
		<section className="ob_detail_container">
			<section className="ob_detail_wrapper">
				<section className="ob_mob ly_mob ">
					<div className="ob_title ly_title  bckBtnDiv">
						<EdButton value={backButtonValue} btnTyp="link" onClick={props.onBackClick} className="icon_button" />
					</div>
					<div className="lv_header">
						<ObAssetsDetlMob {...assetDetail} />
						{/* when status is rejected will show below content */}
						{props.data.remarks && props.data.status.toLowerCase() === "rejected" && (
							<div className="rjct_reason">
								<p className="rsn_hd">Reason</p>
								<p className="rsn">{props.data.remarks}</p>
							</div>
						)}
					</div>
					<div className="ob_content_mob ly_content_mob ">
						<ObMfDtlContent data={props.data} onCancelClick={props.onCancelClick} />
					</div>
				</section>
			</section>
		</section>
	);
};

export default ObMfDtlMob;
